import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class CamDeposit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      camDepositDetails: this.props.camDepositDetails,
      camDepositApplicable: this.props.camDepositApplicable,
    };
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {this.state.camDepositApplicable == "yes" ? (
              Object.keys(this.state.camDepositDetails).map(function (
                key,
                index
              ) {
                return this.state.camDepositDetails[key].map(function (
                  cam,
                  index
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {cam.period}
                              {` `}
                              {`( Period Term - ${
                                cam.periodTermYY == "" ? "0" : cam.periodTermYY
                              }Y -${
                                cam.periodTermMM == "" ? "0" : cam.periodTermMM
                              }M -${
                                cam.periodTermDD == "" ? "0" : cam.periodTermDD
                              }D )`}
                              {` -`}
                              {` `}
                              {cam.camDepositNature}
                              {` - `}
                              {`From ${leaseDateFormat(cam.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(cam.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.periodTermYY == ""
                                            ? "0"
                                            : cam.periodTermYY}
                                          {"-"}
                                          {cam.periodTermMM == ""
                                            ? "0"
                                            : cam.periodTermMM}
                                          {"-"}
                                          {cam.periodTermDD == ""
                                            ? "0"
                                            : cam.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Deposit Nature (RDEP){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camDepositNature}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {/* {dateFormat(
                                          cam.fromDate,
                                          "dd mmm yyyy"
                                        )} */}
                                          {leaseDateFormat(cam.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {/* {dateFormat(
                                            cam.toDate,
                                            "dd mmm yyyy"
                                          )} */}
                                          {leaseDateFormat(cam.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CDEP # Months{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.months}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CDEP Rate UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.rateUOM}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CDEP # Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.rate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CDEP On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CDEP Total Amount{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {Math.round(cam.totalAmount)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          CDEP MileStones
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple tableSimpleWithNoFlex">
                                              <thead>
                                                <tr>
                                                  <th scope="col">
                                                    Milestone Name
                                                  </th>
                                                  <th scope="col">Due Date</th>
                                                  <th scope="col">
                                                    CDEP Milestone
                                                  </th>
                                                  <th scope="col">
                                                    RDEP Milestone Amount (Rs.)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {cam.milestones.length > 0 &&
                                                  cam.milestones.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>
                                                          {name.milestoneName}
                                                        </td>
                                                        <td>
                                                          {leaseDateFormat(
                                                            name.dueDate
                                                          )}
                                                        </td>
                                                        <td>
                                                          {Math.round(
                                                            name.milestonePercent
                                                          )}
                                                          {cam.milestones[index]
                                                            .milestoneType ==
                                                          "CDEP Percent"
                                                            ? " %"
                                                            : " Months"}
                                                        </td>
                                                        <td>
                                                          {Math.round(
                                                            name.amount
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                },
                this);
              },
              this)
            ) : (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <h6 className="text-center" style={{ padding: "15px" }}>
                      CAM Deposit Not Applicable
                    </h6>
                  </div>
                </div>
              </div>
            )}
          </Accordion>
          {this.state.camDepositApplicable == "yes" && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Notes
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.props.cdNotes}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(CamDeposit);
